var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.493,
    height: 21.722,
    viewBox: "0 0 26.493 21.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M242.408,18.92V0l-.722.061a27.764,27.764,0,0,0-8.416,2.051L232,2.639V21.484l.925-.385a28.881,28.881,0,0,1,8.7-2.117Zm0,0",
    transform: "translate(-218.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M275.484,47.3h-1.419V63.855a.473.473,0,0,1-.434.473l-1.212.1q-.525.043-1.046.107c-.113.014-.225.032-.337.047-.234.031-.468.063-.7.1-.136.022-.271.047-.406.071-.209.036-.418.073-.626.114-.142.028-.284.06-.429.091-.2.042-.4.085-.593.132-.148.035-.295.072-.441.11-.191.047-.382.1-.572.152-.148.041-.3.084-.444.127-.189.056-.376.113-.562.172l-.438.142q-.281.095-.559.2c-.142.052-.284.1-.429.158l-.194.076h10.843Zm0,0",
    transform: "translate(-248.99 -44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.722.061,40,0V18.921l.84.071a28.688,28.688,0,0,1,8.7,2.129l.872.363V2.639l-1.269-.527A27.762,27.762,0,0,0,40.722.061Zm0,0",
    transform: "translate(-37.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,47.3V66.221H10.851c-.058-.023-.116-.047-.175-.069-.135-.052-.272-.1-.408-.15-.192-.07-.384-.138-.578-.2q-.21-.071-.421-.138-.288-.095-.578-.178c-.142-.042-.284-.083-.426-.123-.195-.054-.389-.1-.585-.155-.142-.036-.284-.073-.429-.107-.2-.047-.4-.091-.6-.134-.142-.031-.284-.062-.426-.09-.206-.041-.413-.077-.621-.113L5.2,64.689c-.229-.036-.458-.067-.687-.1-.116-.015-.231-.034-.347-.047q-.52-.063-1.041-.107l-1.274-.108a.473.473,0,0,1-.433-.473V47.3Zm0,0",
    transform: "translate(0 -44.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.42cc1aeb097dae9e67bdff74fa281667.svg";
export { ForwardRef as ReactComponent };